import { StytchContext } from '../providers/StytchProvider';
import React from 'react';

export function useAuth() {
  return React.useContext(StytchContext);
}
